
let styles = {
  container: {
    padding: '3%',
    display: 'flex',
    justifyContent: 'center',
  },

  table: {
    backgroundColor: 'white',
    padding: '1%',
  },

  items: {
    padding: '1%',
    display:'flex',
    flexDirection:'row'
  },

  item_header: {
    fontSize: '120%',
    fontWeight: 600,
    paddingLeft: '10%',
    width:'50%'
  },

  item_body: {
    padding: '6px ',
    width:'50%'
  },

  main_header: {
    padding: '1%',
    marginBottom: '3%',
    backgroundColor: '#84DCF2',
  },

  button_submit: {
    padding: '1%',
    justifyContent: 'center',
    display: 'flex',
    paddingTop: '6%',
  },

  eventbutton1: {
    margin : '1%',
    backgroundColor: '#3CB3E2',
    color: 'white',
    borderRadius: '4px',
    fontSize: '14px',
    fontWeight:'bold',
    padding:'5px 30px 5px 30px'
  },
  eventbutton2:{
    color: 'red',
    cursor:'pointer',
    fontSize: 'x-large',
    fontWeight:'900',
    float:'right'
  },

  input: {
    width: '40%',
  },

  success: {
    textAlign: 'center',
    fontSize: '120%',
    fontWeight: 800,
  }
}
export default styles



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addTournament/style.js